export default __webpack_public_path__ + "static/kari-a44a9bc7ae94584f0015dff2f6ab21ed.png";